import { failedOrdersColumns } from "./utils/tableColumnsSchema"
import { useGetFailedOrdersQuery } from "@apis/orders/useOrders"
import { FailedOrdersTable } from "./FailedOrdersTable"

export const FailedOrders = () => {
  const { data, isPending, isError, error } = useGetFailedOrdersQuery()

  if (isError) {
    return (
      <div className="tw:py-4 tw:text-red-500">
        There was an error loading the Failed Orders. Error: {error.message}
      </div>
    )
  }

  return (
    <div className="tw:container tw:mx-auto tw:py-10">
      <FailedOrdersTable
        columns={failedOrdersColumns}
        data={data}
        pending={isPending}
      />
    </div>
  )
}
